import { Button, Dialogß } from '@otter-ai/den-components';

type ClosingDialogProps = {
  onConfirmClose: () => void;
  setShowCloseConfirmDailog: (show: boolean) => void;
};

export function UploadCloseConfirmationDialog({
  onConfirmClose,
  setShowCloseConfirmDailog,
}: ClosingDialogProps) {
  const handleConfirmClose = () => {
    setShowCloseConfirmDailog(false);
    onConfirmClose();
  };

  const handleCancel = () => {
    setShowCloseConfirmDailog(false);
  };

  return (
    <Dialogß
      data-testid="upload-close-confirmation-dialog"
      className="w-[350px] md:w-[560px] text-center text-lg"
      onOpenChange={() => setShowCloseConfirmDailog(false)}
      title="Your file is still uploading"
    >
      <div className="flex flex-col items-center justify-center px-14 border-b border-t border-palette-gray-200">
        <div className="pt-3 pb-2 text-lg font-semibold">
          Are you sure you want to close this screen?
        </div>
        <div className="pb-5 text-subtle">
          Closing this screen will lose all uploading progress that has not
          completed.
        </div>
      </div>
      <div className="flex items-center justify-center gap-6 py-5 px-4 font-semibold">
        <Button
          className="w-28 rounded-sm"
          onClick={handleCancel}
          size="lg"
          variant="outlineNeutral"
        >
          No
        </Button>
        <Button
          className="w-28 rounded-sm"
          onClick={handleConfirmClose}
          size="lg"
          variant="primary"
        >
          Yes, close
        </Button>
      </div>
    </Dialogß>
  );
}
